import { CheerzApiSettings } from "@Types/api/settings";
import { SettingsContent } from "@Types/settings";

export const convertSettingsFromApiToContent = (
  apiResponse: CheerzApiSettings["response"]
): SettingsContent => {
  return {
    country3: apiResponse.country_code3,
    currency: apiResponse.currency_code3,
    lang: apiResponse.lang,
  };
};
